import React, {memo, useEffect} from 'react';
import styled from 'styled-components';

function getReaction(id) {
    switch (id) {
        case '1':
            return require('../../assets/reactions/reaction_1.png');
        case '2':
            return require('../../assets/reactions/reaction_2.png');
        case '3':
            return require('../../assets/reactions/reaction_3.png');
        case '4':
            return require('../../assets/reactions/reaction_4.png');
        default:
            return require('../../assets/reactions/reaction_5.png');
    }
}

function ReactionElement({id, reaction, fromUser, onFinished}) {
    //this is a bit complicated. Path must have a origin point and 3 control points to control the curve upwards
    //initial point is based on the emoji index from the user. If its null, its from the server and we ignore the first part of the path
    //example path fromUser = 2
    //M -160 0 C -126 46 0 44 0 0 C 0 -84 -38 -86 -38 -150 C -38 -198 -20 -202 -20 -252 C -20 -284 -20 -306 -64 -342
    let path;
    let x1 = -80 + Math.random() * 80; //add some randomness to each control point
    let x2 = -80 + Math.random() * 80;
    let x3 = -80 + Math.random() * 100;
    if (fromUser) {
        //initial point base on fromUser value (0-4)
        path = `M ${-20 - fromUser * 60} 0 C -126 46 0 44 0 0`;
        //randomize the next 3 points their original positions: -38, -20, -65

        //first curve. y is fixed, we just translate x a bit from original position
        path += ` C 0 -84 ${x1} -86 ${x1} -150`;
        //second curve. y is fixed, we just translate x a bit from original position
        path += ` C ${x1} -198 ${x2} -202 ${x2} -252`;
        //third curve. y is fixed, we just translate x a bit from original position
        path += ` C ${x2} -284 ${x2} -306 ${x3} -342`;
    } else {
        //same thing, but we use this path (no initial point)
        //M 0 0 C 0 -84 -38 -86 -38 -150 C -38 -198 -20 -202 -20 -252 C -20 -284 -20 -306 -65 -342
        path = `M 0 0 C 0 -84 ${x1} -86 ${x1} -150`;
        path += ` C ${x1} -198 ${x2} -202 ${x2} -252`;
        path += ` C ${x2} -284 ${x2} -306 ${x3} -342`;
    }

    useEffect(() => {
        //element animation timeout
        let timeout = setTimeout(() => {
            onFinished(id);
        }, 1950);
        return () => {
            clearTimeout(timeout);
        };

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Container>
            <Item path={path}>
                <Reaction src={getReaction(reaction)} />
            </Item>
        </Container>
    );
}

const Container = styled.div`
    position: absolute;

    @-webkit-keyframes travel {
        0% {
            offset-distance: 0%;
        }
        20% {
            offset-distance: 40%;
        }
        100% {
            offset-distance: 100%;
        }
    }
    @keyframes travel {
        0% {
            offset-distance: 0%;
        }
        20% {
            offset-distance: 40%;
        }

        100% {
            offset-distance: 100%;
        }
    }

    @keyframes size {
        0% {
            scale: 0.4;
            opacity: 1;
        }
        60% {
            scale: 1;
            opacity: 1;
        }

        70% {
            scale: 1;
            opacity: 1;
        }

        100% {
            scale: 0.3;
            opacity: 0;
        }
    }
`;

const Item = styled.div`
    width: 50px;
    height: 50px;
    offset-path: path(
        '${props => props.path}'
    );
    -webkit-animation: travel 2s linear;
    animation: travel 2s linear;
    transform: rotate(90deg);
`;

const Reaction = styled.img`
    width: 50px;
    height: 50px;
    -webkit-animation: size 2s linear;
    animation: size 2s linear;
`;

export default memo(ReactionElement);

//path example
//M 0 0 C 20 20 80 22 80 0 C 80 -6 71 -5 72 -15 C 73 -22 80 -24 79 -30 C 77 -36 74 -40 75 -44
